var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinoHappyAsync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 145,
    viewBox: "0 0 104 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3234 48.833H14.6432C11.2062 48.833 8.41987 51.6193 8.41987 55.0564V129.737C8.41987 133.174 11.2062 135.96 14.6432 135.96H89.3234C92.7605 135.96 95.5468 133.174 95.5468 129.737V55.0564C95.5468 51.6193 92.7605 48.833 89.3234 48.833ZM14.6432 40.5352C6.62341 40.5352 0.12207 47.0366 0.12207 55.0564V129.737C0.12207 137.756 6.62341 144.258 14.6432 144.258H89.3234C97.3433 144.258 103.845 137.756 103.845 129.737V55.0564C103.845 47.0366 97.3433 40.5352 89.3234 40.5352H14.6432Z",
    fill: "#000E4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6074 80.4687C27.6074 78.1773 29.4649 76.3198 31.7563 76.3198C34.0477 76.3198 35.9052 78.1773 35.9052 80.4687V90.8409C35.9052 93.1323 34.0477 94.9898 31.7563 94.9898C29.4649 94.9898 27.6074 93.1323 27.6074 90.8409V80.4687Z",
    fill: "#000E4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6172 80.4686C69.6172 78.1773 71.4747 76.3197 73.7661 76.3197C76.0575 76.3197 77.915 78.1773 77.915 80.4686V90.8409C77.915 93.1323 76.0575 94.9898 73.7661 94.9898C71.4747 94.9898 69.6172 93.1323 69.6172 90.8409V80.4686Z",
    fill: "#000E4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5089 89.4195C54.158 91.0611 49.3127 90.0933 47.5268 89.4195C46.4549 89.015 45.2581 89.5561 44.8536 90.6281C44.4492 91.7 44.9903 92.8968 46.0622 93.3013C48.4252 94.1929 54.3671 95.4166 59.9735 93.3013C61.0454 92.8968 61.5865 91.7 61.1821 90.6281C60.7776 89.5561 59.5808 89.015 58.5089 89.4195Z",
    fill: "#000E4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7229 30.6816C44.7229 27.531 47.277 24.9769 50.4276 24.9769C53.5783 24.9769 56.1324 27.531 56.1324 30.6816V43.1283C56.1324 46.2789 53.5783 48.833 50.4276 48.833C47.277 48.833 44.7229 46.2789 44.7229 43.1283V30.6816Z",
    fill: "#000E4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.283 33.2747C61.4287 33.2747 62.3574 34.2035 62.3574 35.3492C62.3574 36.4949 61.4287 37.4237 60.283 37.4237L40.5757 37.4237C39.43 37.4237 38.5012 36.4949 38.5012 35.3492C38.5012 34.2035 39.43 33.2747 40.5757 33.2747L60.283 33.2747Z",
    fill: "#000E4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9101 8.3813C45.3273 8.3813 41.6123 12.0964 41.6123 16.6791V19.2677C41.6123 22.1549 42.7592 24.9239 44.8008 26.9655L48.1763 30.341L42.3088 36.2084L38.9334 32.833C35.3356 29.2352 33.3145 24.3557 33.3145 19.2677V16.6791C33.3145 7.5136 40.7446 0.0834961 49.9101 0.0834961V8.3813Z",
    fill: "#000E4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9076 8.3813C54.4903 8.3813 58.2054 12.0964 58.2054 16.6791V19.2677C58.2054 22.1549 57.0584 24.9239 55.0168 26.9655L51.6414 30.341L57.5088 36.2084L60.8843 32.833C64.482 29.2352 66.5032 24.3557 66.5032 19.2677V16.6791C66.5032 7.5136 59.0731 0.0834961 49.9076 0.0834961V8.3813Z",
    fill: "#000E4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9525 126.625V104.843C67.3922 111.318 40.6546 111.592 14.9674 105.64L11.5303 104.843V126.625L15.0675 126.064C40.8837 121.971 67.1979 122.161 92.9525 126.625Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoHappyAsync);
export default __webpack_public_path__ + "static/media/dinoHappyAsync.579b613b2003efcce6f9db713e8e9a67.svg";
export { ForwardRef as ReactComponent };